import { useAuth } from "@/context/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, Lock } from "lucide-react";

const SubscriptionBanner = () => {
  const { access } = useAuth();
  const location = useLocation();
  if (!access) return null;
  if (location.pathname.startsWith("/upgrade") || location.pathname.startsWith("/admin")) return null;
  if (access.status === "grandfathered" || access.status === "active" || access.status === "promo") return null;

  if (access.status === "trial" && access.trial_days_left > 0) {
    return (
      <Link
        to="/upgrade"
        className="flex items-center justify-between gap-4 px-6 py-3 bg-amber-500/10 border-b border-amber-500/30 text-sm hover:bg-amber-500/15 transition-colors"
        data-testid="trial-banner"
      >
        <div className="flex items-center gap-2 text-amber-300">
          <Sparkles className="w-4 h-4" />
          <span><strong>Free trial:</strong> {access.trial_days_left} day{access.trial_days_left === 1 ? "" : "s"} left — then $19/mo</span>
        </div>
        <span className="text-amber-400 hover:underline">Upgrade now →</span>
      </Link>
    );
  }

  // trial expired
  return (
    <Link
      to="/upgrade"
      className="flex items-center justify-between gap-4 px-6 py-3 bg-red-500/10 border-b border-red-500/30 text-sm hover:bg-red-500/15 transition-colors"
      data-testid="expired-banner"
    >
      <div className="flex items-center gap-2 text-red-300">
        <Lock className="w-4 h-4" />
        <span><strong>Trial expired</strong> — subscribe to unlock Coach, Tools, Playbooks, Recovery &amp; Date Planner</span>
      </div>
      <span className="text-red-300 hover:underline">Subscribe →</span>
    </Link>
  );
};

export default SubscriptionBanner;
